import { Alert } from '@cmsgov/design-system';

import { Button, ButtonVariation } from '../Button';

function AccessDeniedPage() {
  const baseTestId = 'access-denied-page';

  return (
    <section
      aria-labelledby={`${baseTestId}-title`}
      data-testid={baseTestId}>
      <h1
        className='ds-text-heading--2xl ds-u-margin-bottom--2'
        data-testid={`${baseTestId}-title`}
        id={`${baseTestId}-title`}>
        403 Access Denied
      </h1>
      <Alert
        data-testid={`${baseTestId}-alert`}
        heading='You do not have permission to view this page.'
        variation='error'>
        <p>Please return to the Home page or contact the CMS IT Service Desk if you believe you should have access.</p>
      </Alert>
      <div className='ds-u-margin-top--3'>
        <Button
          isAutoWidth
          data-testid={`${baseTestId}-home-link`}
          href='/'
          variation={ButtonVariation.SOLID}>
          Return to Home
        </Button>
      </div>
    </section>
  );
}

export default AccessDeniedPage;
